/**
 * @generated
 * This file was automatically generated and should not be manually edited.
 *
 * Auto-generated enum for: boards.tag
 *
 * To regenerate: npm run db:codegen
 * Any manual changes will be overwritten on next generation.
 */

/* eslint-disable */
// @ts-nocheck

/**
 * BoardTag enum representing allowed values for boards.tag
 */
export enum BoardTag {
  /** Primary */
  PRIMARY = 'primary',
  /** Secondary */
  SECONDARY = 'secondary',
  /** Personal */
  PERSONAL = 'personal',
  /** Cohort */
  COHORT = 'cohort',
}
